export type Mode = 'client' | 'supplier' | 'federated' | '';

export function assertIsMode(mode: string): asserts mode is Mode {
  if (!['client', 'supplier', 'federated', ''].includes(mode as string)) {
    throw new Error('Invalid mode');
  }
}
